export default __webpack_public_path__ + "static/media/logo-full.7e45c1c7.svg";